import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController, PopoverController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MenuService } from 'src/app/services/menu/menu.service';
import { PopoverPage } from 'src/app/views/popover/popover.page';

@Component({
  selector: 'app-custom-header',
  templateUrl: './custom-header.component.html',
  styleUrls: ['./custom-header.component.scss'],
  standalone: false
})
export class CustomHeaderComponent {
  constructor(
    private pop: PopoverController,
    public auth: AuthService,
    public router: Router,
    private menu: MenuService,
  ) {
    
  }
  gotoHome(){
    this.router.navigate(['home']);
  }
  open(){
    this.menu.showMenu();
  }


  async presentPopover(event: Event) {
    const pop = this.pop.create({
      component: PopoverPage,
      event,
    });
    return (await pop).present();
  }
  async gotoMessages() {
    // console.log('123')
     this.router.navigate(['/messages']);
  }
  async gotoNotifications() {
    console.log('123');
     this.router.navigate(['/notifications']);
  }

  ionViewWillEnter(){
    // Try to remove META-Tags
    // try{
    //   document.querySelector('meta[name=\'description\']').remove();
    // } catch (e){

    // }

    // // Add the new META-Tags
    // const description = document.createElement('meta');
    // description.name = 'description';
    // description.content = 'Arrow Product Performance Evaluation';
    // document.getElementsByTagName('head')[0].appendChild(description);


  }
}
